import { useState } from 'react';
import Validator from 'validatorjs';
import React, { useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import Manager from './planesderetiro/Manager';
import { FormControl } from '../../../../facturotopia';
import SiNoOption from '../../support/catalogos/SiNoOptions';
import ComplementoPlanesDeRetiroRules from '../../support/rules/complementos/planesderetiro/ComplementoPlanesDeRetiroRules';

const rulesCallback = ComplementoPlanesDeRetiroRules;

const ComplementoPlanesderetiro = (props) => {
  const [data, setData] = useState({});
  const [validation, setValidation] = useState({
    validator: new Validator({}, rulesCallback()),
    isValid: false,
  });

  const { isValid } = validation;

  const handleOnChange = (event) => {
    const newData = {
      ...data,
      ...event,
    };

    setData(newData);
  };

  const handleOnAportacionesODepositosAdd = (event) => {
    const newData = {
        ...data,
        ...event
    };

    setData( newData );
  }

  const rules = rulesCallback(data);

  const validate = (data) => {
    const validator = new Validator(data, rules);

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidation(newValidator);
  };

  useEffect(() => validate(data), [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnAddComplemento = () => {
    let AportacionesODepositosNew = [];
    const { AportacionesODepositos = {} } = data;

    AportacionesODepositos.map( (aportaciones) =>
      AportacionesODepositosNew = [].concat(AportacionesODepositosNew, [{
        TipoAportacionODeposito: aportaciones.TipoAportacionODeposito,
        MontAportODep: aportaciones.MontAportODep,
        RFCFiduciaria: aportaciones.RFCFiduciaria
      }])
    );

    const Planesderetiro = {
      Version: '1.1',
      SistemaFinanc: data.SistemaFinanc,
      MontTotAportAnioInmAnterior: data.MontTotAportAnioInmAnterior,
      MontIntRealesDevengAniooInmAnt: data.MontIntRealesDevengAniooInmAnt,
      HuboRetirosAnioInmAntPer: data.HuboRetirosAnioInmAntPer,
      MontTotRetiradoAnioInmAntPer: data.MontTotRetiradoAnioInmAntPer,
      MontTotExentRetiradoAnioInmAnt: data.MontTotExentRetiradoAnioInmAnt,
      MontTotExedenteAnioInmAnt: data.MontTotExedenteAnioInmAnt,
      HuboRetirosAnioInmAnt: data.HuboRetirosAnioInmAnt,
      MontTotRetiradoAnioInmAnt: data.MontTotRetiradoAnioInmAnt,
      NumReferencia: data.NumReferencia,
      AportacionesODepositos: AportacionesODepositosNew
    };

    props.onComplementoAdd({ Planesderetiro });

    clear();
  };

  const clear = () => {
    setData({});
  };

  const handleOutForm = () => {
    props.onCancel();
  };

  return (
    <>
      <h5 className="text-right">Planes de retiro</h5>

      <Form autoComplete="off">
        <Row>
          <Col sm md={ 4 }>
            <FormControl
              type="select"
              label="Sistema financiero"
              name="SistemaFinanc"
              placeholder=""
              help=""
              rules={ rules.SistemaFinanc }
              value={ data.SistemaFinanc }
              options={ SiNoOption }
              onChange={ handleOnChange }
            />
          </Col>
          <Col sm md={ 4 }>
            <FormControl
              type="number"
              label="Monto total aportaciones (Año anterior)"
              name="MontTotAportAnioInmAnterior"
              placeholder=""
              help=""
              rules={ rules.MontTotAportAnioInmAnterior }
              value={ data.MontTotAportAnioInmAnterior }
              onChange={ handleOnChange }
            />
          </Col>
          <Col sm md={ 4 }>
            <FormControl
              type="number"
              label="Monto intereses reales(Año anterior)"
              name="MontIntRealesDevengAniooInmAnt"
              placeholder=""
              help=""
              rules={ rules.MontIntRealesDevengAniooInmAnt }
              value={ data.MontIntRealesDevengAniooInmAnt }
              onChange={ handleOnChange }
            />
          </Col>
          <Col sm md={ 4 }>
            <FormControl
              type="select"
              label="Hubo retiros"
              name="HuboRetirosAnioInmAntPer"
              placeholder=""
              help=""
              rules={ rules.HuboRetirosAnioInmAntPer }
              value={ data.HuboRetirosAnioInmAntPer }
              options={ SiNoOption }
              onChange={ handleOnChange }
            />
          </Col>
          <Col sm md={ 4 }>
            <FormControl
              type="number"
              label="Monto total retirado"
              name="MontTotRetiradoAnioInmAntPer"
              placeholder=""
              help="Si hay un valor será la suma de :Monto total exento retirado + :Monto total exedente"
              rules={ rules.MontTotRetiradoAnioInmAntPer }
              value={ data.MontTotRetiradoAnioInmAntPer }
              onChange={ handleOnChange }
            />
          </Col>
          <Col sm md={ 4 }>
            <FormControl
              type="number"
              label="Monto total exento retirado"
              name="MontTotExentRetiradoAnioInmAnt"
              placeholder=""
              help=""
              rules={ rules.MontTotExentRetiradoAnioInmAnt }
              value={ data.MontTotExentRetiradoAnioInmAnt }
              onChange={ handleOnChange }
            />
          </Col>
          <Col sm md={ 4 }>
            <FormControl
              type="number"
              label="Monto total exedente"
              name="MontTotExedenteAnioInmAnt"
              placeholder=""
              help=""
              rules={ rules.MontTotExedenteAnioInmAnt }
              value={ data.MontTotExedenteAnioInmAnt }
              onChange={ handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl
              type="select"
              label="Hubo retiros año anterior"
              name="HuboRetirosAnioInmAnt"
              placeholder=""
              help=""
              rules={ rules.HuboRetirosAnioInmAnt }
              value={ data.HuboRetirosAnioInmAnt }
              options={ SiNoOption }
              onChange={ handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl
              type="number"
              label="Monto total retirado (Año anterior)"
              name="MontTotRetiradoAnioInmAnt"
              placeholder=""
              help=""
              rules={ rules.MontTotRetiradoAnioInmAnt }
              value={ data.MontTotRetiradoAnioInmAnt }
              onChange={ handleOnChange }
            />
          </Col>
        </Row>
        <Row>
          <Col sm md={12}>
            <FormControl
              as="textarea"
              label="Número de referencia"
              name="NumReferencia"
              placeholder=""
              help=""
              rows="4"
              minLength="1"
              maxLength="301"
              rules={ rules.NumReferencia }
              value={ data.NumReferencia }
              onChange={ handleOnChange }
            />
          </Col>
        </Row>
        <Manager
          onAportacionesODepositosAdd={ handleOnAportacionesODepositosAdd }
        />
        <Row>
          <Col>
            <Button
              variant="secondary"
              className="mr-2"
              onClick={handleOutForm}
            >
              Cancelar
            </Button>

            <Button
              variant="primary"
              disabled={!isValid}
              onClick={handleOnAddComplemento}
            >
              Agregar complemento
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ComplementoPlanesderetiro;
